'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = deleteItem;
/**
 * Deletes an item from a list.
 *
 * @param {string}	list Name of the list to delete from
 * @param {string}	id Id of the item to delete
 *
 * @return {Promise<number>} id of deleted item.
 */
function deleteItem(list, id) {
    return new Promise(function (resolve, reject) {
        window.SP.SOD.executeFunc('sp.js', 'SP.ClientContext', function () {
            var ctx = window.SP.ClientContext.get_current();
            var path = window._spPageContextInfo.webAbsoluteUrl + '/Lists/' + list;
            var item = ctx.get_web().getList(path).getItemById(id);
            ctx.load(item);
            ctx.executeQueryAsync(function () {
                item.deleteObject();
                ctx.executeQueryAsync(function () {
                    resolve(id);
                }, function (sender, args) {
                    reject(sender, args);
                });
            }, function (sender, args) {
                reject(sender, args);
            });
        });
    });
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/ntnu-react/util/sp/deleteItem.js
// module id = 1038
// module chunks = 0